import { generateSchema } from "@/components/forms/Form/schemaHelpers";

const schema = generateSchema({
    schema: [
        {
            component: "KText",
            type: "text",
            name: "username",
            label: "Användarnamn",
            validation: "required",
            autofocus: true,
            validationName: "Användarnamn",
            class: "span-all",
        },
        {
            component: "KText",
            type: "password",
            name: "password",
            label: "Lösenord",
            validation: "required",
            validationName: "Lösenord",
            class: "span-all",
        },
    ],
});

export default schema;
